import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../services/message.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'ngx-widget-setup-temperature',
    templateUrl: './widget.setup.temperature.component.html',
    styleUrls: ['./widget.setup.temperature.component.scss'],
})

export class WidgetSetupTemperatureComponent implements OnInit {

    form: FormGroup;
    data: any;
    availableSensors: Array<String> = [];
    addWidget: boolean;

    constructor(private activeModal: NgbActiveModal,
                private messageService: MessageService,
                private formBuilder: FormBuilder) {

        const self = this;

        this.data = {
            name: 'Weather widget',
        };

        // console.log(this.config);


        this.messageService.getGatewayPhisicalDevices(function(status, obj){

            // console.log({status, obj});

            if (status === true) {
                for (let i = 0; i < obj.length; ++i) {

                    const dev = obj[i];

                     if (dev.vendor === 'RFM69' && dev.deviceType === 1) {
                        self.availableSensors.push(dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId);
                    }
                }
            }
        });

    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            widgetName: [null, Validators.required],
            source: [null, Validators.required],
        });





        if (this.data['id'] !== undefined) {
            this.addWidget = false;
        }else {
            this.addWidget = true;
        }
    }

    onSubmit() {
        // console.log(JSON.stringify(this.data));

        this.messageService.saveWidget('temperature', this.data);
        this.messageService.syncAllWidgets();
        this.activeModal.close();
        // window.location.reload();

    }

    closeModal() {
        this.activeModal.close();
    }


    private pad(i: number): string {
        return i < 10 ? `0${i}` : `${i}`;
    }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.setup.temperature.component.ts